import React from 'react'
import {
  Detail,
  Details,
  TitleGroup,
  Price,
  Seller,
  InfoArea,
  InfoAreaColumn,
} from '@/modern/components/Card'
import BrandOfferStamp from '@/modern/components/Stamps/BrandOffer'
import {
  AlignHorizontalInfoAreaStamp,
  AlignFlagsStamp,
} from '../style'
import Stamp0km from '@/modern/components/Stamps/0kmStamp'
import {FlexColumnStart, LinkInfoAreaSmartLead} from './style'

const InfoAreaSmartLeadHorizontal = ({
  id,
  model,
  make,
  version,
  price,
  year,
  travelledDistance,
  href = '#',
  stamps = {},
  dispatchDataLayer
}) => {
  const linkProps = { rel: 'nofollow', target: '_blank', href }

  return (
    <InfoArea isHorizontal>

      <FlexColumnStart>
        <LinkInfoAreaSmartLead {...linkProps} onClick={()=> dispatchDataLayer()}>
          <TitleGroup
            needsRightSpace={stamps.superPreco}
            title={`${make} ${model}`}
            subtitle={version}
            isHorizontal
          />

          <AlignFlagsStamp>
            <Stamp0km stamps={stamps} />
          </AlignFlagsStamp>
        </LinkInfoAreaSmartLead>

        <Details minHeight="30px" isHorizontal>
          <Detail>
            <Seller value={year} />
          </Detail>
          <Detail>
            <Seller value={travelledDistance} />
          </Detail>
        </Details>

      </FlexColumnStart>

      <InfoAreaColumn>
        <AlignHorizontalInfoAreaStamp>
          <BrandOfferStamp brand={make} />
        </AlignHorizontalInfoAreaStamp>
        <Price isHorizontal value={price} />
      </InfoAreaColumn>
    </InfoArea>
  )
}

export default InfoAreaSmartLeadHorizontal
